// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__pNWe5","active":"styles_active__buNYY"};